// ============================================================================
// ADHKAR SEO & DYNAMIC ROUTING UTILITIES
// ============================================================================

export interface AdhkarSEOConfig {
  id: string;
  slug: string;
  title: {
    ar: string;
    en: string;
  };
  description: {
    ar: string;
    en: string;
  };
  keywords: {
    ar: string[];
    en: string[];
  };
  metaTitle: {
    ar: string;
    en: string;
  };
  metaDescription: {
    ar: string;
    en: string;
  };
}

export const adhkarSEOConfigs: AdhkarSEOConfig[] = [
  {
    id: 'morning',
    slug: 'adhkar-morning',
    title: {
      ar: 'أذكار الصباح - أذكار وأدعية الصباح كاملة',
      en: 'Morning Azkar - Complete Morning Supplications'
    },
    description: {
      ar: 'أذكار الصباح كاملة مع العداد التفاعلي. اقرأ أذكار الصباح وأدعية الصباح مع التكرار المطلوب لكل ذكر.',
      en: 'Complete morning Azkar with interactive counter. Read morning supplications with required repetitions for each dhikr.'
    },
    keywords: {
      ar: ['أذكار الصباح', 'أدعية الصباح', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'الصباح'],
      en: ['morning azkar', 'morning supplications', 'adhkar', 'duas', 'islamic', 'dhikr', 'morning']
    },
    metaTitle: {
      ar: 'أذكار الصباح كاملة مع العداد | أذكاري',
      en: 'Complete Morning Azkar with Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار الصباح كاملة مع العداد التفاعلي. اقرأ أذكار الصباح وأدعية الصباح مع التكرار المطلوب لكل ذكر.',
      en: 'Complete morning Azkar with interactive counter. Read morning supplications with required repetitions for each dhikr.'
    }
  },
  {
    id: 'evening',
    slug: 'adhkar-evening',
    title: {
      ar: 'أذكار المساء - أذكار وأدعية المساء كاملة',
      en: 'Evening Azkar - Complete Evening Supplications'
    },
    description: {
      ar: 'أذكار المساء كاملة مع العداد التفاعلي. اقرأ أذكار المساء وأدعية المساء مع التكرار المطلوب لكل ذكر.',
      en: 'Complete evening Azkar with interactive counter. Read evening supplications with required repetitions for each dhikr.'
    },
    keywords: {
      ar: ['أذكار المساء', 'أدعية المساء', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'المساء'],
      en: ['evening azkar', 'evening supplications', 'adhkar', 'duas', 'islamic', 'dhikr', 'evening']
    },
    metaTitle: {
      ar: 'أذكار المساء كاملة مع العداد | أذكاري',
      en: 'Complete Evening Azkar with Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار المساء كاملة مع العداد التفاعلي. اقرأ أذكار المساء وأدعية المساء مع التكرار المطلوب لكل ذكر.',
      en: 'Complete evening Azkar with interactive counter. Read evening supplications with required repetitions for each dhikr.'
    }
  },
  {
    id: 'after-salah',
    slug: 'adhkar-after-prayer',
    title: {
      ar: 'أذكار بعد الصلاة - أذكار وأدعية ما بعد الصلاة',
      en: 'After Prayer Azkar - Post-Prayer Supplications'
    },
    description: {
      ar: 'أذكار بعد الصلاة كاملة مع العداد التفاعلي. اقرأ أذكار وأدعية ما بعد الصلاة المفروضة.',
      en: 'Complete after prayer Azkar with interactive counter. Read post-prayer supplications for obligatory prayers.'
    },
    keywords: {
      ar: ['أذكار بعد الصلاة', 'أدعية بعد الصلاة', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'الصلاة'],
      en: ['after prayer azkar', 'post-prayer supplications', 'adhkar', 'duas', 'islamic', 'dhikr', 'prayer']
    },
    metaTitle: {
      ar: 'أذكار بعد الصلاة كاملة مع العداد | أذكاري',
      en: 'Complete After Prayer Azkar with Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار بعد الصلاة كاملة مع العداد التفاعلي. اقرأ أذكار وأدعية ما بعد الصلاة المفروضة.',
      en: 'Complete after prayer Azkar with interactive counter. Read post-prayer supplications for obligatory prayers.'
    }
  },
  {
    id: 'sleep',
    slug: 'adhkar-sleep',
    title: {
      ar: 'أذكار النوم - أذكار وأدعية النوم والاستيقاظ',
      en: 'Sleep Azkar - Sleep and Wake Up Supplications'
    },
    description: {
      ar: 'أذكار النوم كاملة مع العداد التفاعلي. اقرأ أذكار النوم وأدعية النوم والاستيقاظ.',
      en: 'Complete sleep Azkar with interactive counter. Read sleep and wake up supplications.'
    },
    keywords: {
      ar: ['أذكار النوم', 'أدعية النوم', 'أذكار الاستيقاظ', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله'],
      en: ['sleep azkar', 'sleep supplications', 'wake up azkar', 'adhkar', 'duas', 'islamic', 'dhikr']
    },
    metaTitle: {
      ar: 'أذكار النوم كاملة مع العداد | أذكاري',
      en: 'Complete Sleep Azkar with Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار النوم كاملة مع العداد التفاعلي. اقرأ أذكار النوم وأدعية النوم والاستيقاظ.',
      en: 'Complete sleep Azkar with interactive counter. Read sleep and wake up supplications.'
    }
  },
  {
    id: 'miscellaneous',
    slug: 'adhkar-miscellaneous',
    title: {
      ar: 'أذكار متفرقة - أذكار وأدعية متنوعة',
      en: 'Miscellaneous Azkar - Various Supplications'
    },
    description: {
      ar: 'أذكار متفرقة ومتنوعة مع العداد التفاعلي. اقرأ أذكار وأدعية متنوعة للاستخدام العام.',
      en: 'Various and miscellaneous Azkar with interactive counter. Read diverse supplications for general use.'
    },
    keywords: {
      ar: ['أذكار متفرقة', 'أدعية متنوعة', 'أذكار عامة', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله'],
      en: ['miscellaneous azkar', 'various supplications', 'general azkar', 'adhkar', 'duas', 'islamic', 'dhikr']
    },
    metaTitle: {
      ar: 'أذكار متفرقة كاملة مع العداد | أذكاري',
      en: 'Complete Miscellaneous Azkar with Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار متفرقة ومتنوعة مع العداد التفاعلي. اقرأ أذكار وأدعية متنوعة للاستخدام العام.',
      en: 'Various and miscellaneous Azkar with interactive counter. Read diverse supplications for general use.'
    }
  },
  {
    id: 'travel',
    slug: 'adhkar-travel',
    title: {
      ar: 'أذكار السفر - أذكار وأدعية السفر والرحلات كاملة',
      en: 'Travel Azkar - Complete Travel and Journey Supplications'
    },
    description: {
      ar: 'أذكار السفر كاملة مع العداد التفاعلي. اقرأ أذكار وأدعية السفر والرحلات لحماية المسافر وتيسير الطريق.',
      en: 'Complete travel Azkar with interactive counter. Read travel and journey supplications for traveler protection and ease of journey.'
    },
    keywords: {
      ar: ['أذكار السفر', 'أدعية السفر', 'أذكار الرحلات', 'دعاء السفر', 'أذكار المسافر', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'السفر', 'الرحلة'],
      en: ['travel azkar', 'travel supplications', 'journey duas', 'travel prayer', 'traveler azkar', 'adhkar', 'duas', 'islamic', 'dhikr', 'travel', 'journey']
    },
    metaTitle: {
      ar: 'أذكار السفر كاملة مع العداد | أذكاري - دعاء المسافر',
      en: 'Complete Travel Azkar with Counter | Adhkar - Traveler Prayer'
    },
    metaDescription: {
      ar: 'أذكار السفر كاملة مع العداد التفاعلي. اقرأ أذكار وأدعية السفر والرحلات لحماية المسافر وتيسير الطريق.',
      en: 'Complete travel Azkar with interactive counter. Read travel and journey supplications for traveler protection and ease of journey.'
    }
  },
  {
    id: 'weather',
    slug: 'adhkar-weather-rain',
    title: {
      ar: 'أذكار الطقس والمطر - أذكار وأدعية المطر والرعد كاملة',
      en: 'Weather & Rain Azkar - Complete Rain and Thunder Supplications'
    },
    description: {
      ar: 'أذكار الطقس والمطر كاملة مع العداد التفاعلي. اقرأ أذكار المطر والرعد والبرق وأدعية الطقس.',
      en: 'Complete weather and rain Azkar with interactive counter. Read rain, thunder, lightning and weather supplications.'
    },
    keywords: {
      ar: ['أذكار المطر', 'أدعية المطر', 'أذكار الرعد', 'أذكار البرق', 'أذكار الطقس', 'دعاء المطر', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'المطر', 'الطقس'],
      en: ['rain azkar', 'rain supplications', 'thunder azkar', 'lightning azkar', 'weather azkar', 'rain prayer', 'adhkar', 'duas', 'islamic', 'dhikr', 'rain', 'weather']
    },
    metaTitle: {
      ar: 'أذكار المطر والطقس كاملة مع العداد | أذكاري - دعاء المطر',
      en: 'Complete Rain & Weather Azkar with Counter | Adhkar - Rain Prayer'
    },
    metaDescription: {
      ar: 'أذكار الطقس والمطر كاملة مع العداد التفاعلي. اقرأ أذكار المطر والرعد والبرق وأدعية الطقس.',
      en: 'Complete weather and rain Azkar with interactive counter. Read rain, thunder, lightning and weather supplications.'
    }
  },
  {
    id: 'illness-healing',
    slug: 'adhkar-illness-healing',
    title: {
      ar: 'أذكار المرض والشفاء - الرقية الشرعية وأدعية الشفاء كاملة',
      en: 'Illness & Healing Azkar - Complete Islamic Healing and Recovery Supplications'
    },
    description: {
      ar: 'أذكار المرض والشفاء كاملة مع العداد التفاعلي. اقرأ الرقية الشرعية وأدعية الشفاء والعافية للمريض.',
      en: 'Complete illness and healing Azkar with interactive counter. Read Islamic healing ruqyah and recovery supplications for the sick.'
    },
    keywords: {
      ar: ['أذكار المرض', 'أدعية الشفاء', 'الرقية الشرعية', 'أذكار الشفاء', 'دعاء المريض', 'أذكار العافية', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'المرض', 'الشفاء', 'الرقية'],
      en: ['illness azkar', 'healing supplications', 'islamic ruqyah', 'healing azkar', 'sick prayer', 'recovery azkar', 'adhkar', 'duas', 'islamic', 'dhikr', 'illness', 'healing', 'ruqyah']
    },
    metaTitle: {
      ar: 'أذكار المرض والشفاء والرقية الشرعية كاملة مع العداد | أذكاري',
      en: 'Complete Illness & Healing Azkar with Islamic Ruqyah & Counter | Adhkar'
    },
    metaDescription: {
      ar: 'أذكار المرض والشفاء كاملة مع العداد التفاعلي. اقرأ الرقية الشرعية وأدعية الشفاء والعافية للمريض.',
      en: 'Complete illness and healing Azkar with interactive counter. Read Islamic healing ruqyah and recovery supplications for the sick.'
    }
  },
  {
    id: 'hajj-umrah',
    slug: 'adhkar-hajj-umrah',
    title: {
      ar: 'أذكار الحج والعمرة - التلبية وأدعية الحج والعمرة كاملة',
      en: 'Hajj & Umrah Azkar - Complete Pilgrimage Supplications and Talbiyah'
    },
    description: {
      ar: 'أذكار الحج والعمرة كاملة مع العداد التفاعلي. اقرأ التلبية وأدعية الحج والعمرة والطواف وعرفة.',
      en: 'Complete Hajj and Umrah Azkar with interactive counter. Read Talbiyah and pilgrimage supplications for Hajj, Umrah, Tawaf and Arafat.'
    },
    keywords: {
      ar: ['أذكار الحج', 'أدعية الحج', 'أذكار العمرة', 'أدعية العمرة', 'التلبية', 'أذكار الطواف', 'أدعية عرفة', 'أذكار', 'أدعية', 'إسلامية', 'ذكر الله', 'الحج', 'العمرة'],
      en: ['hajj azkar', 'hajj supplications', 'umrah azkar', 'umrah duas', 'talbiyah', 'tawaf azkar', 'arafat prayers', 'adhkar', 'duas', 'islamic', 'dhikr', 'hajj', 'umrah', 'pilgrimage']
    },
    metaTitle: {
      ar: 'أذكار الحج والعمرة والتلبية كاملة مع العداد | أذكاري - دليل الحاج',
      en: 'Complete Hajj & Umrah Azkar with Talbiyah & Counter | Adhkar - Pilgrim Guide'
    },
    metaDescription: {
      ar: 'أذكار الحج والعمرة كاملة مع العداد التفاعلي. اقرأ التلبية وأدعية الحج والعمرة والطواف وعرفة.',
      en: 'Complete Hajj and Umrah Azkar with interactive counter. Read Talbiyah and pilgrimage supplications for Hajj, Umrah, Tawaf and Arafat.'
    }
  }
];

// Utility functions
export const getAdhkarSEOConfig = (id: string): AdhkarSEOConfig | undefined => {
  return adhkarSEOConfigs.find(config => config.id === id);
};

export const getAdhkarSEOConfigBySlug = (slug: string): AdhkarSEOConfig | undefined => {
  return adhkarSEOConfigs.find(config => config.slug === slug);
};

export const getAllAdhkarSlugs = (): string[] => {
  return adhkarSEOConfigs.map(config => config.slug);
};

export const generateCanonicalUrl = (slug: string, baseUrl: string = 'https://yourdomain.com'): string => {
  return `${baseUrl}/adhkar/${slug}`;
};

export const generateStructuredData = (config: AdhkarSEOConfig, lang: 'ar' | 'en') => {
  return {
    "@context": "https://schema.org",
    "@type": ["WebPage", "ItemList"],
    "name": config.title[lang],
    "description": config.description[lang],
    "url": generateCanonicalUrl(config.slug),
    "inLanguage": lang === 'ar' ? 'ar-SA' : 'en-US',
    "dateModified": new Date().toISOString(),
    "datePublished": "2024-01-01T00:00:00.000Z",
    "author": {
      "@type": "Organization",
      "name": lang === 'ar' ? 'أذكاري' : 'Adhkar App',
      "url": "https://yourdomain.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": lang === 'ar' ? 'أذكاري' : 'Adhkar App',
      "url": "https://yourdomain.com"
    },
    "mainEntity": {
      "@type": "ItemList",
      "name": config.title[lang],
      "description": config.description[lang],
      "numberOfItems": getItemCountByCategory(config.id),
      "itemListElement": generateItemListElements(config, lang)
    },
    "isPartOf": {
      "@type": "WebSite",
      "name": lang === 'ar' ? 'أذكاري - تطبيق الأذكار الإسلامية' : 'Adhkar - Islamic Supplications App',
      "alternateName": lang === 'ar' ? 'أذكاري' : 'Adhkar',
      "url": "https://yourdomain.com",
      "description": lang === 'ar' 
        ? 'تطبيق شامل للأذكار الإسلامية مع العداد التفاعلي وأذكار الصباح والمساء والسفر والمرض والحج والعمرة'
        : 'Comprehensive Islamic supplications app with interactive counter for morning, evening, travel, illness, and pilgrimage azkar',
      "sameAs": [
        "https://yourdomain.com/adhkar"
      ]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": lang === 'ar' ? 'الرئيسية' : 'Home',
          "item": "https://yourdomain.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": lang === 'ar' ? 'أذكاري' : 'Adhkar',
          "item": "https://yourdomain.com/adhkar"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": config.title[lang],
          "item": generateCanonicalUrl(config.slug)
        }
      ]
    },
    "about": {
      "@type": "Thing",
      "name": lang === 'ar' ? 'الأذكار الإسلامية' : 'Islamic Supplications',
      "description": lang === 'ar'
        ? 'الأذكار والأدعية الإسلامية الصحيحة من القرآن الكريم والسنة النبوية الشريفة'
        : 'Authentic Islamic supplications and remembrances from the Quran and Prophetic Sunnah'
    },
    "keywords": config.keywords[lang].join(', '),
    "audience": {
      "@type": "Audience",
      "audienceType": lang === 'ar' ? 'المسلمون' : 'Muslims'
    }
  };
};

// Helper functions for structured data
const getItemCountByCategory = (categoryId: string): number => {
  // This would normally import from adhkar data, but to avoid circular imports
  // we'll use a simple mapping. In production, you might want to dynamically calculate this.
  const itemCounts: Record<string, number> = {
    'morning': 25,
    'evening': 17,
    'after-salah': 8,
    'sleep': 11,
    'miscellaneous': 21,
    'travel': 5,
    'weather': 5,
    'illness-healing': 4,
    'hajj-umrah': 4
  };
  return itemCounts[categoryId] || 0;
};

const generateItemListElements = (config: AdhkarSEOConfig, lang: 'ar' | 'en') => {
  // Generate basic item list elements based on category
  const itemCount = getItemCountByCategory(config.id);
  const elements = [];
  
  for (let i = 1; i <= Math.min(itemCount, 5); i++) { // Limit to first 5 items for structured data
    elements.push({
      "@type": "ListItem",
      "position": i,
      "name": `${config.title[lang]} - ${lang === 'ar' ? 'الذكر' : 'Dhikr'} ${i}`,
      "description": lang === 'ar' 
        ? `ذكر رقم ${i} من ${config.title[lang]}`
        : `Dhikr number ${i} from ${config.title[lang]}`
    });
  }
  
  return elements;
};
